import { render, staticRenderFns } from "./PatientsForm.vue?vue&type=template&id=1a5220b2&"
import script from "./PatientsForm.vue?vue&type=script&lang=js&"
export * from "./PatientsForm.vue?vue&type=script&lang=js&"
import style0 from "./PatientsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports